/**
 * Definition of different constant values
 * 
 * @author Harsh Tomar
 */

export enum PaddleProduct {
  LTD = 807866,
  SUBSCRIPTION_LIMITED = 809654,
  SUBSCRIPTION_UNLIMITED = 810386
}